import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody } from "reactstrap";

import "./style.scss";
import { H5, MUIIcons, ToolTip } from "../../AbstractElements";
import {
  Assessments,
  Courses,
  LearningPlan,
  UserGroups,
  Users,
  ViewDetails,
} from "../../utils/Constant";

interface DomainCardProps {
  domainName: string;
  learningPlans: number;
  courses: number;
  assessments: number;
  users: number;
  userGroups: number;
  id: string;
}

const DomainCard: React.FC<DomainCardProps> = ({
  domainName,
  learningPlans,
  courses,
  assessments,
  users,
  userGroups,
  id,
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    return navigate(
      `${process.env.PUBLIC_URL}/master-data/active-learning-plans?id=${id}`
    );
  };

  return (
    <Card className="domain-card">
      <CardBody className="d-flex justify-content-between align-items-center flex-wrap gap-2 pt-4 pb-4">
        <span id={`tooltip-course-name-${id}`}>
          <div className="text-ellips-parent">
            <div
              className="domain-title header-text truncated-header text-ellips domain-title mb-0"
              data-fulltext={domainName}
            >
              {domainName}
            </div>
          </div>
        </span>
        <ToolTip placement="top" target={`tooltip-course-name-${id}`}>
          {domainName}
        </ToolTip>

        <div className="domain-stats">
          <div className="stat-item no-divider">
            {learningPlans} {LearningPlan}
          </div>
          <div className="divider" />
          <div className="stat-item">
            <MUIIcons size={20} className="icon" iconName="BookOutlined" />{" "}
            <div className="text-muted">
              {Courses}: {courses}
            </div>
          </div>
          <div className="divider" />
          <div className="stat-item">
            <MUIIcons
              size={20}
              className="icon"
              iconName="DescriptionOutlined"
            />{" "}
            <div className="text-muted">
              {Assessments}: {assessments}
            </div>
          </div>
          <div className="divider" />
          <div className="stat-item">
            <MUIIcons size={20} className="icon" iconName="PersonOutlined" />{" "}
            <div className="text-muted">
              {Users}: {users}
            </div>
          </div>
          <div className="divider" />
          <div className="stat-item">
            <MUIIcons size={20} className="icon" iconName="GroupsOutlined" />{" "}
            <div className="text-muted">
              {UserGroups}: {userGroups}
            </div>
          </div>
        </div>

        <div
          onClick={handleNavigate}
          className="view-details d-flex align-items-center gap-1 pointer"
        >
          <H5 className="primary-text-color mb-0">{ViewDetails}</H5>
          <MUIIcons
            size={16}
            className="primary-icon-color"
            iconName="ArrowForwardOutlined"
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default DomainCard;
